var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_WebDevelopmnt",
    "data-name": "Icon/WebDevelopmnt",
    transform: "translate(-1083 -1051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-programming",
    transform: "translate(1083 1056.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    "data-name": "Path 4285",
    d: "M124.888,198.225a1.319,1.319,0,0,1-.857-.316l-8.566-7.294a1.324,1.324,0,0,1,0-2.016l8.566-7.294a1.323,1.323,0,1,1,1.716,2.015l-7.382,6.286,7.382,6.286a1.324,1.324,0,0,1-.859,2.332Zm0,0",
    transform: "translate(-93.045 -146.767)",
    fill: "#f7d51b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    d: "M251.032,198.225a1.324,1.324,0,0,1-.859-2.332l7.382-6.286-7.382-6.286a1.323,1.323,0,0,1,1.716-2.015l8.566,7.294a1.324,1.324,0,0,1,0,2.016l-8.566,7.294A1.319,1.319,0,0,1,251.032,198.225Zm0,0",
    transform: "translate(-202.035 -146.767)",
    fill: "#f7d51b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    "data-name": "Path 4287",
    d: "M190.28,181.02a1.347,1.347,0,0,1-.275-.029,1.324,1.324,0,0,1-1.022-1.568l5.339-25.347a1.324,1.324,0,1,1,2.591.546l-5.339,25.347A1.324,1.324,0,0,1,190.28,181.02Zm0,0",
    transform: "translate(-152.895 -124.091)",
    fill: "#f7d51b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4288",
    "data-name": "Path 4288",
    d: "M71.88,70.736H8.961A8.934,8.934,0,0,1,0,61.849V8.887A8.935,8.935,0,0,1,8.961,0H71.88a8.935,8.935,0,0,1,8.961,8.887V61.849A8.934,8.934,0,0,1,71.88,70.736ZM8.961,2.647a6.273,6.273,0,0,0-6.292,6.24V61.849a6.273,6.273,0,0,0,6.292,6.24H71.88a6.273,6.273,0,0,0,6.292-6.24V8.887a6.273,6.273,0,0,0-6.292-6.24Zm0,0",
    transform: "translate(0 0)",
    fill: "#36297d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4289",
    "data-name": "Path 4289",
    d: "M79.506,100.737H1.335a1.324,1.324,0,1,1,0-2.648H79.506a1.324,1.324,0,1,1,0,2.648Zm0,0",
    transform: "translate(0 -79.542)",
    fill: "#36297d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4290",
    "data-name": "Path 4290",
    d: "M101.638,42.667a4.189,4.189,0,1,1,4.189-4.189A4.195,4.195,0,0,1,101.638,42.667Zm0-5.731a1.542,1.542,0,1,0,1.542,1.542A1.544,1.544,0,0,0,101.638,36.937Zm0,0",
    transform: "translate(-78.852 -27.805)",
    fill: "#36297d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    "data-name": "Path 4291",
    d: "M33.576,42.453a4.189,4.189,0,1,1,4.189-4.189A4.194,4.194,0,0,1,33.576,42.453Zm0-5.731a1.542,1.542,0,1,0,1.542,1.542A1.544,1.544,0,0,0,33.576,36.722Zm0,0",
    transform: "translate(-23.829 -27.63)",
    fill: "#36297d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    "data-name": "Path 4292",
    d: "M169.7,42.882a4.189,4.189,0,1,1,4.189-4.189A4.194,4.194,0,0,1,169.7,42.882Zm0-5.731a1.542,1.542,0,1,0,1.542,1.542A1.543,1.543,0,0,0,169.7,37.151Zm0,0",
    transform: "translate(-133.928 -27.979)",
    fill: "#36297d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5550",
    "data-name": "Rectangle 5550",
    width: 81,
    height: 81,
    transform: "translate(1083 1051)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5596",
    "data-name": "Rectangle 5596",
    width: 81,
    height: 81,
    transform: "translate(1083 1051)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/web-development.27e255c3b8e94157742fa16248c9851f.svg";
export { ForwardRef as ReactComponent };